import React from 'react'
import { GetServerSideProps, NextPage } from 'next'
import { getSEOServersideProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import { fetchArticles } from 'services/ContentfulService/hooks/articles'
import { ArticleSummary, summarizeArticles } from 'services/ContentfulService/models/articles'
import { getTopics } from 'services/ContentfulService/hooks/topics'
import { Topic, TopicTypeSorter, VisibleTopics } from 'services/ContentfulService/models/topics'
import { ContentfulHookProps } from 'services/ContentfulService/hooks/template'
import { NamedPromises } from 'lib'
import { TopicsDirectory } from 'experiences/learn/topics/TopicDirectoryPage'
import { ProductWithChildren } from 'services/ContentfulService/models/product'
import { OrderByNewestConstraint } from 'services/ContentfulService/constraints'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { getProducts } from 'lib/cache/productTree'

interface Props {
	topics: Topic[]
	latestArticles: ArticleSummary[]
	products: ProductWithChildren[]
}

const topicsInput: ContentfulHookProps = { constraints: [], count: 100, include: 1 }
const TopicsDirectoryPage: NextPage<PagePropsWrapper<Props>> = ({ metaTags, pageProps }) => {
	return (
		<StandardLayout metaTags={metaTags}>
			<TopicsDirectory
				topics={VisibleTopics(pageProps.topics)}
				products={pageProps.products}
				latestArticles={pageProps.latestArticles}
			/>
		</StandardLayout>
	)
}

export const getServerSideProps: GetServerSideProps = getSEOServersideProps<Props>(
	async () => {
		return await NamedPromises({
			topics: getTopics(topicsInput).then(topics => topics.sort(TopicTypeSorter)),
			products: getProducts(),
			latestArticles: fetchArticles({ constraints: [OrderByNewestConstraint()], count: 8 }).then(summarizeArticles)
		})
	},
	metadataTags => {
		return {
			...metadataTags,
			title: 'Topics | Fiona Learn',
			description: 'Learn about anything finance: based on product, milestones or persona'
		}
	}
)

export default TopicsDirectoryPage
